import {t} from "@lingui/core/macro";
import {lazy} from "react";

import {color} from "@khanacademy/wonder-blocks-tokens";

import {Layout, ToolCategories, type Tool} from "../types.ts";

import textColumnsIcon from "@phosphor-icons/core/regular/text-columns.svg";

const CoeditingDocumentTool = lazy(
    () => import("../renderers/coediting-document-tool.tsx"),
);

export const chunkText: Tool = {
    urlSlug: "chunk-text",
    configName: "teacher-tool-chunk-text",
    title: () => t`Chunk text`,
    description: () =>
        t`Break complex texts into manageable sections for easier student comprehension`,
    categories: [
        ToolCategories.Differentiate,
        ToolCategories.Create,
        ToolCategories.Support,
    ],
    icon: textColumnsIcon,
    color: color.fadedRed24,
    layout: Layout.Coeditor,
    reportingLabelId: "chunk-text",
    exportTargets: [
        "print",
        "download-pdf",
        "download-docx",
        "google-drive-docx",
        "microsoft-onedrive-docx",
    ],
    requestedInputs: [
        {
            description: () => "",
            inputKind: "TEXT_BOX",
            label: () => t`Text title`,
            required: true,
            variableName: "textTitle",
        },
        {
            description: () =>
                t`Input the text you'd like to be chunked. This works best on texts with 1,500 words or less.`,
            inputKind: "TEXT_AREA",
            label: () => t`Text`,
            maxCharacters: 26000,
            required: true,
            variableName: "inputText",
        },
        {
            description: () => "",
            inputKind: "SINGLE_SELECT",
            label: () => t`What type of chunks?`,
            required: true,
            selectOptions: [
                {
                    label: () =>
                        t`Chunk a longer text by ideas for comprehension`,
                    value: "chunk-a-longer-text-by-ideas-for-comprehension",
                },
                {
                    label: () => t`Chunk a shorter text by phrases for fluency`,
                    value: "chunk-a-shorter-text-by-phrases-for-fluency",
                },
            ],
            variableName: "coeditSelectedTemplate",
        },
    ],
    component: ({providedInputs, configName, debugMode}) => {
        return (
            <CoeditingDocumentTool
                configName={configName}
                providedInputs={providedInputs}
                debugMode={debugMode}
            />
        );
    },
};
